import { Card, CardHeader, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { SkeletonButton, SkeletonText, SkeletonTitle } from '@/components/ui/skeleton-base'

/**
 * Skeleton component for the upsell edit page loading state
 */
export const UpsellEditSkeleton = () => (
	<div className="bg-background min-h-screen">
		<div className="flex flex-col space-y-4 sm:space-y-6">
			<div className="mb-4 flex items-center justify-between">
				<div className="flex items-center gap-2">
					<Skeleton className="h-10 w-10" />
					<div>
						<SkeletonTitle className="w-48" />
						<SkeletonText className="w-64 mt-2" />
					</div>
				</div>
				<div className="flex gap-2">
					<SkeletonButton />
					<SkeletonButton />
				</div>
			</div>

			<div className="space-y-6">
				<Card>
					<CardHeader>
						<SkeletonTitle className="w-40" />
					</CardHeader>
					<CardContent className="space-y-6">
						<div className="space-y-2">
							<SkeletonText className="w-24" />
							<Skeleton className="h-10 w-full" />
						</div>
						<div className="space-y-2">
							<SkeletonText className="w-24" />
							<Skeleton className="h-10 w-full" />
						</div>
						<div className="flex items-center justify-between">
							<div className="space-y-1">
								<SkeletonText className="w-32" />
								<SkeletonText className="w-48" />
							</div>
							<Skeleton className="h-6 w-11 rounded-full" />
						</div>
					</CardContent>
				</Card>

				<Card>
					<CardHeader>
						<SkeletonTitle className="w-32" />
						<SkeletonText className="w-64 mt-2" />
					</CardHeader>
					<CardContent className="space-y-4">
						<div className="space-y-2">
							<SkeletonText className="w-32" />
							<Skeleton className="h-10 w-full" />
							<SkeletonText className="w-48" />
						</div>
						<div className="space-y-2">
							<SkeletonText className="w-40" />
							<Skeleton className="h-32 w-full" />
						</div>
					</CardContent>
				</Card>

				<Card>
					<CardHeader>
						<SkeletonTitle className="w-40" />
						<SkeletonText className="w-64 mt-2" />
					</CardHeader>
					<CardContent>
						<div className="space-y-4">
							<Skeleton className="h-48 w-full" />
							<SkeletonButton />
						</div>
					</CardContent>
				</Card>
			</div>
		</div>
	</div>
)

